import { render, staticRenderFns } from "./SingleProjectSubtask.vue?vue&type=template&id=137f22ba&scoped=true&"
import script from "./SingleProjectSubtask.vue?vue&type=script&lang=js&"
export * from "./SingleProjectSubtask.vue?vue&type=script&lang=js&"
import style0 from "./SingleProjectSubtask.vue?vue&type=style&index=0&id=137f22ba&prod&scoped=true&lang=css&"
import style1 from "./SingleProjectSubtask.vue?vue&type=style&index=1&id=137f22ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f22ba",
  null
  
)

export default component.exports